module.exports = __webpack_public_path__ + "img/seta-baixo.d98d0c2d.svg";